var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "208.8%",
    height: "208.8%",
    x: "-54.4%",
    y: "-50.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.439360119 0 0 0 0 0.439360119 0 0 0 0 0.439360119 0 0 0 0.14 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__b",
    cx: 57,
    cy: 57,
    r: 57
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(40 36)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3A78F2",
    d: "M6.338 42.324C2.843 42.324 0 45.167 0 48.662S2.843 55 6.338 55c1.186 0 2.148-.962 2.148-2.148 0-1.187-.962-2.149-2.148-2.149-1.126 0-2.041-.915-2.041-2.04 0-1.126.915-2.042 2.04-2.042 1.126 0 2.042.916 2.042 2.041 0 1.187.962 2.149 2.148 2.149 1.187 0 2.149-.962 2.149-2.149 0-3.495-2.843-6.338-6.338-6.338z",
    transform: "translate(30 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6C2D4",
    d: "M19.55 8.486h33.302c1.186 0 2.148-.962 2.148-2.148 0-1.187-.962-2.149-2.148-2.149H19.55c-1.187 0-2.149.962-2.149 2.149 0 1.186.962 2.148 2.149 2.148z",
    transform: "translate(30 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A78F2",
    d: "M6.338 21.162C2.843 21.162 0 24.005 0 27.5s2.843 6.338 6.338 6.338c1.186 0 2.148-.962 2.148-2.149 0-1.186-.962-2.148-2.148-2.148-1.126 0-2.041-.916-2.041-2.041s.915-2.041 2.04-2.041c1.126 0 2.042.916 2.042 2.041 0 1.187.962 2.148 2.148 2.148 1.187 0 2.149-.961 2.149-2.148 0-3.495-2.843-6.338-6.338-6.338z",
    transform: "translate(30 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6C2D4",
    d: "M52.852 25.352H19.55c-1.187 0-2.149.961-2.149 2.148 0 1.187.962 2.148 2.149 2.148h33.3c1.187 0 2.149-.961 2.149-2.148 0-1.187-.962-2.148-2.148-2.148zM52.852 46.514H19.55c-1.187 0-2.149.962-2.149 2.148 0 1.187.962 2.149 2.149 2.149h33.3c1.187 0 2.149-.962 2.149-2.149 0-1.186-.962-2.148-2.148-2.148z",
    transform: "translate(30 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A78F2",
    d: "M6.338 0C2.843 0 0 2.843 0 6.338s2.843 6.338 6.338 6.338c1.186 0 2.148-.962 2.148-2.149 0-1.186-.962-2.148-2.148-2.148-1.126 0-2.041-.916-2.041-2.041 0-1.126.915-2.041 2.04-2.041 1.126 0 2.042.915 2.042 2.04 0 1.187.962 2.15 2.148 2.15 1.187 0 2.149-.963 2.149-2.15C12.676 2.844 9.833 0 6.338 0z",
    transform: "translate(30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollType);
export default __webpack_public_path__ + "static/media/poll_type.0cd24c88.svg";
export { ForwardRef as ReactComponent };